<template>
  <div class="nav-menu">
    <div class="row border-bottom">
      <nav class="navbar navbar-static-top" role="navigation">

        <div class="navbar-header">
          <a class="minimalize-styl-2 btn btn-success" @click="collapse()"><i class="fa fa-bars"></i> </a>
        </div>

        <ul class="nav navbar-top-links navbar-right">

          <li><current-company-selector></current-company-selector></li>

          <li class="dropdown">

            <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
              <i class="fa fa-bell"></i>
              <span :class="notifications.count == 0 ? 'label' : 'label label-success'">{{ notifications.count }}</span>
            </a>

            <ul class="dropdown-menu dropdown-alerts">

              <li v-if="notifications.content.length == 0">
                <a href="#">
                  <div class="text-center">
                    Sem Notificações Recentes
                  </div>
                </a>
              </li>

              <li v-for="notif in notifications.content" :key="notif.id">
                <a href="#">
                  <div>
                    <i :class="notif.icon"></i> {{ notif.tittle }}
                    <span class="pull-right text-muted small">{{ notif.time }}</span>
                  </div>
                </a>
              </li>

              <li class="divider"></li>

              <li>
                <a href="/lockscreen">
                  <div>
                    <i class="fa fa-lock fa-fw"></i>
                    Bloqueio de tela <strong>Alt+T</strong>
                  </div>
                </a>
              </li>

              <li class="divider"></li>

              <li>
                <div class="text-center link-block">
                  <a href="#">
                    <strong>Ver tudo</strong>
                    <i class="fa fa-angle-right"></i>
                  </a>
                </div>
              </li>
            </ul>
          </li>

          <li><products-popover></products-popover></li>

          <li> &nbsp; | &nbsp; </li>

          <li>
            <a href="" data-toggle="modal"
              data-target="#exitModal" @click.prevent>
              <i class="fa fa-sign-out"></i> Sair
            </a>
          </li>
        </ul>
      </nav>

      <!-- MODAL DE SAIR -->
      <div class="modal inmodal fade" id="exitModal" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
                <span class="sr-only">Close</span>
              </button>
              <i class="fa fa-sign-out modal-icon"></i>
              <h4 class="modal-title"> DESEJA REALMENTE SAIR ? </h4>
            </div>
            <div class="modal-body">
              <p>
                Deseja realmente sair <strong>{{ user.name }}</strong>?
                Todo trabalho não finalizado será <strong>PERDIDO DEFINITIVAMENTE</strong>, deseja prosseguir?
              </p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-white" data-dismiss="modal"> Cancelar </button>

              <button type="button" class="btn btn-danger" data-dismiss="modal"
                @click.prevent="exit()">&nbsp; Sair &nbsp;
              </button>
            </div>
          </div>
        </div>
      </div>


    </div>
  <login-component></login-component>
  </div>
</template>

<script>

  import { mapGetters, mapActions } from 'vuex'
  import { httpService } from '../../providers/http-service'
  import ProductsPopover from './ProductsPopover'
  import LoginComponent from '../LoginComponent'
  import CurrentCompanySelector from './CurrentCompanySelector'

  export default {
    components: { ProductsPopover,  CurrentCompanySelector, LoginComponent },
    data() {
      return {
        user: {},
        notifications: {
          count: 0,
          content: [ ]
        }
      }
    },
    methods: {
      ...mapGetters(['getLoggedUser', 'getCollapseState']),
      ...mapActions(['removeLoggedUser']),

      exit() {
        this.removeLoggedUser({})
        localStorage.removeItem('token')
        this.$router.push({ path: '/' })
      },

      collapse() {
        const collapse = !this.$store.state.collapsed
        this.$store.state.collapsed = collapse
        const animationAdd = collapse ? 'collapse-animation' : 'expand-animation'
        const animationRemove = collapse ? 'expand-animation' : 'collapse-animation'
        const page = $('#page-wrapper').addClass(animationAdd).removeClass(animationRemove)
        setTimeout(() => { page.toggleClass('collapsed') }, 100)
      }
    },
    mounted() {
      if(this.$store.state.collapsed) $('#page-wrapper').addClass('collapsed')
      this.user = this.getLoggedUser()
    }
  }
</script>

<style scoped>

  nav { margin-bottom: 0; }
  .minimalize-styl-2 {width: 40px; }
  .modal-body p {
    text-align: center;
    font-size: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/NavMenu.vue